import {
  DeleteEvaluationFormDocument,
  DeleteEvaluationFormMutation,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useDeleteEvaluationForm = (evaluationFormId: string) => {
  const [deleteEvaluationForm, { loading }] = useMutation(DeleteEvaluationFormDocument, {
    extractorFn: (data: DeleteEvaluationFormMutation) => data.atsMutations.deleteAtsEvaluationForm,
  })

  return {
    loading,
    deleteEvaluationForm() {
      return deleteEvaluationForm({
        variables: { id: evaluationFormId },
        update(cache, mutationResult) {
          if (mutationResult.data?.atsMutations.deleteAtsEvaluationForm.evaluationForm) {
            cache.evict({ id: `AtsEvaluationForm:${evaluationFormId}` })
          }
        },
      })
    },
  }
}
